/* The name of each cookie used by the site */
export const cookieNames = {
	cookiesAccepted: "cookies-accepted",
};
